import {
    Document,
    PDFViewer,
    Page as PDFPage,
    StyleSheet,
    Text as PDFText,
    View as PDFView,
    Image as PDFImage,
    Font
  } from '@react-pdf/renderer';
  
  // Registering custom fonts
  Font.register({
    family: 'Roboto',
    fonts: [
      { src: '/Roboto-Bold.ttf', fontWeight: 'bold' },
    ],
  });
  
  const styles = StyleSheet.create({
    page: {
      padding: 20
    },
    heading: {
      fontSize: 18,
      textAlign: 'center',
      marginBottom: 20
    },
    line: {
      height: 0.6,
      backgroundColor: 'black',
      marginVertical: 10,
      marginTop: '40px'
    },
    line2: {
      height: 0.4,
      backgroundColor: 'black',
      marginVertical: 10
    },
    contentContainer: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      marginTop: 0,
      marginBottom: 0,
      border: '1px Solid black',
      padding: '10px'
    },
    contentContainer2: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      marginTop: 0,
      marginBottom: 0
    },
    column: {
      flex: 1,
      paddingHorizontal: 10
    },
    row: {
      flexDirection: 'row',
      marginBottom: 0
    },
    text: {
      fontSize: 9,
      display: 'inline-block'
    },
    textBold: {
      fontSize: 9,
      fontWeight: 'bold'
    },
    textUnderlined: {
      textDecoration: 'underline'
    },
  
    columnHeader: {
      width: '15%',
      backgroundColor: '#1976D2',
      color: 'white',
      padding: 5,
      textAlign: 'center'
    },
    columnContent: {
      width: '15%',
      padding: 6,
      textAlign: 'center',
      alignItems: 'center'
    }
  });
  
  const fullScreenStyles = {
    container: {
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100vw',
      height: '100vh',
      zIndex: 1000,
      backgroundColor: 'white'
    }
  };
  
  const COLORS = ['#f0f0f0', '#e0e0e0'];
  
  const Page = ({ style, children, ...props }) => (
    <PDFPage style={{ ...styles.page, ...style }} {...props}>
      {children}
    </PDFPage>
  );
  
  const View = ({ style, children, ...props }) => (
    <PDFView style={{ ...style }} {...props}>
      {children}
    </PDFView>
  );
  
  const Text = ({ style, content, ...props }) => (
    <PDFText style={{ ...styles.text, ...style }} {...props}>
      {content}
    </PDFText>
  );
  
  export const ServicePackageReportPdf = ({ data }) => {
    console.log(data);
    const user = JSON.parse(localStorage.getItem('user'));
    let totalRecdCash = 0;
  
    // Function to format the date as needed (e.g., dd/mm/yyyy)
    function formatDate(dateString) {
      const date = new Date(dateString);
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
      const year = date.getFullYear();
      return `${day}/${month}/${year}`;
    }
  
    return (
      <div style={fullScreenStyles.container}>
        <PDFViewer width="100%" height="100%" showToolbar>
          <Document title="Service Package Report">
            <Page style={styles.page} size="A4" orientation="landscape">
              {/* Hospital Logo */}
              <PDFImage
                src="/logo_Hospital_m.jpeg"
                style={{ width: '100%', height: '80px', marginBottom: 1, marginRight: '10%' }}
              />
              <View style={styles.row}>
                <Text style={{...styles.columnHeader, width:'8%'}} content="Sr No." />
                <Text style={styles.columnHeader} content="Service Type" />
                <Text style={{ ...styles.columnHeader, width: "28%" }} content="Service Name" />
                <Text style={{ ...styles.columnHeader, width: "20%" }} content="Main Group" />
                <Text style={styles.columnHeader} content="Sub Group" />
                <Text style={{ ...styles.columnHeader }} content="OPD Charges" />
                <Text style={{ ...styles.columnHeader }} content="IPD Charges" />
              </View>
  
              {/* Data Rows */}
              {data && data.map((item, index) => {
                totalRecdCash += item.ipd_charges + item.opd_charges; // Assuming charges are the total amount
  
                return (
                  <View key={index} style={{ ...styles.row, backgroundColor: COLORS[index % COLORS.length] }}>
                    <Text style={{...styles.columnContent, width:'8%'}} content={index + 1} />
                    <Text style={styles.columnContent} content={item.type} />
                    <Text style={{ ...styles.columnContent, width: '28%', textAlign:'left' }} content={item.service_name} />
                    <Text style={{ ...styles.columnContent, width: '20%', textAlign:'left' }} content={item.main_group.groupname} />
                    <Text style={styles.columnContent} content={item.sub_group.subgroupname} />
                    <Text style={styles.columnContent} content={item.opd_charges} />
                    <Text style={styles.columnContent} content={item.ipd_charges} />
                  </View>
                );
              })}
        
            </Page>
          </Document>
        </PDFViewer>
      </div>
    );
  };
  
  export default ServicePackageReportPdf;
  